import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-selection-gift-card',
  templateUrl: './selection-gift-card.component.html',
  styleUrls: ['./selection-gift-card.component.scss'],
})
export class SelectionGiftCardComponent implements OnInit {
  @Input() users: any[] = [];

  public giftCards = [];
  public id = undefined;
  private _card = undefined;
  public resend = false;
  public selectedType = 'giftCard';

  constructor(
    private httpSv: HttpService,
    private modalController: ModalController,
    private uiSv: UiServices,
    private translateSv: TranslateService
  ) {}

  ngOnInit() {
    this.getGiftCards();
  }

  async getGiftCards() {
    try {
      const params = {
        pag: '',
        search: '',
      };
      const res: any = await this.httpSv.itemIndex(
        this.selectedType,
        '',
        params,
        'all/index'
      );
      this.giftCards = res.data;
    } catch (err) {
      console.error(err);
    }
  }

  close() {
    this.modalController.dismiss();
  }

  async selectCard(card) {
    this._card = card;
    this.id = card.id;
  }

  async sendCard() {
    const body = {
      usersId: this.users,
      giftCardId: this._card.id,
      repeat: this.resend,
    };
    const res = await this.httpSv.itemAction(
      body,
      'admin/giftCard',
      'sendGiftCardUsers'
    );
    if (res.status) {
      const translate = this.translateSv.instant('GIFT_CARD_ENVIADA_CON_EXITO');
      this.uiSv.showToast(translate);
      this.close();
    }
  }
}
